import Image from 'next/image'

import { CopyrightText } from '@/components/copyright-text'

import { GuardianLayout } from '../guardian'

interface ChallengeSignUpLayoutProps {
  title?: string
  headerRightNode?: React.ReactNode
  children: React.ReactNode
}

export const ChallengeSignUpLayout = ({
  title,
  headerRightNode,
  children,
}: ChallengeSignUpLayoutProps): JSX.Element => {
  return (
    <GuardianLayout>
      <main className="flex min-h-screen flex-col bg-basic-bg">
        <header className="flex h-[50px] items-center bg-white px-[10px] md:h-[60px] md:px-[24px] lg:h-[70px]">
          <div className="flex-1">
            <Image
              src="/logiq-challenge-logo.svg"
              width={115}
              height={33}
              className="md:h-[44px] md:w-[153px]"
              alt="LogiQlabo Challenge"
            />
          </div>
          <div className="flex-1">
            {title && (
              <h2 className="text-center text-[11px] font-bold text-secondary-text md:text-[18px] lg:text-[20px]">
                {title}
              </h2>
            )}
          </div>
          <div className="flex flex-1 justify-end">{headerRightNode}</div>
        </header>
        <div className="flex grow flex-col">{children}</div>

        <footer className="mt-auto py-3.5">
          <p className="text-center text-[10px] font-medium text-secondary-93 md:text-xs">
            <CopyrightText />
          </p>
        </footer>
      </main>
    </GuardianLayout>
  )
}
